import {
  CustomSelect,
  ItemSource,
  useCustomSelectStateFromItemSource,
} from 'components/inputs/CustomSelect'
import { observer } from 'mobx-react'
import React from 'react'

const matches = (item: string, text: string) =>
  item.toLowerCase().includes(text.toLowerCase())

interface MultiStringSelectProps {
  value: string[]
  options: readonly string[]
  onChange: (value: string[]) => void
  placeholder?: string
  disabled?: boolean
  dataTest?: string
}

export const MultiStringSelect = observer(function MultiStringSelect({
  value,
  options,
  onChange,
  placeholder,
  disabled,
  dataTest,
}: MultiStringSelectProps) {
  const itemSource = React.useMemo(
    () => ItemSource.static([...options], matches),
    [options],
  )
  const selectProps = useCustomSelectStateFromItemSource({ itemSource })
  return (
    <CustomSelect
      {...selectProps}
      multi
      persist
      value={value}
      onChange={(next) => onChange(next ?? [])}
      placeholder={placeholder}
      disabled={disabled}
      data-test={dataTest}
    />
  )
})

interface SingleStringSelectProps {
  value: string | undefined
  options: readonly string[]
  onChange: (value: string | undefined) => void
  placeholder?: string
  disabled?: boolean
  dataTest?: string
}

export const SingleStringSelect = observer(function SingleStringSelect({
  value,
  options,
  onChange,
  placeholder,
  disabled,
  dataTest,
}: SingleStringSelectProps) {
  const itemSource = React.useMemo(
    () => ItemSource.static([...options], matches),
    [options],
  )
  const selectProps = useCustomSelectStateFromItemSource({ itemSource })
  return (
    <CustomSelect
      {...selectProps}
      multi={false}
      value={value}
      onChange={(next) => onChange(next ?? undefined)}
      placeholder={placeholder}
      disabled={disabled}
      data-test={dataTest}
    />
  )
})
